var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"edit 2\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3846 13.3677H0.615385C0.278974 13.3677 0 13.1435 0 12.8731C0 12.6028 0.278974 12.3785 0.615385 12.3785H15.3846C15.721 12.3785 16 12.6028 16 12.8731C16 13.1435 15.721 13.3677 15.3846 13.3677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.7602 1.15587C12.1684 -0.123471 10.6094 -0.156444 8.97661 1.15587L7.98379 1.95381C7.90174 2.01975 7.86892 2.12527 7.90174 2.21759C8.52533 3.96514 10.2648 5.36318 12.4392 5.86435C12.472 5.87095 12.5048 5.87754 12.5376 5.87754C12.6279 5.87754 12.7099 5.85116 12.7756 5.79841L13.7602 5.00048C14.5725 4.35422 14.9664 3.72774 14.9664 3.09466C14.9746 2.4418 14.5807 1.80873 13.7602 1.15587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.962 6.46408C10.724 6.37176 10.4943 6.27943 10.2727 6.17392C10.0922 6.08819 9.91992 5.99587 9.74761 5.89695C9.60812 5.82441 9.44402 5.7189 9.28813 5.61339C9.27172 5.60679 9.21428 5.56722 9.14864 5.51447C8.87787 5.32981 8.57428 5.09241 8.30351 4.82862C8.27889 4.81543 8.23787 4.76927 8.18043 4.70992C8.09838 4.63079 7.95889 4.4989 7.83582 4.34722C7.73736 4.2483 7.62248 4.10322 7.51582 3.95815C7.38454 3.78009 7.26966 3.60204 7.15479 3.41739C7.1374 3.38746 7.12058 3.35767 7.10433 3.32806C6.98322 3.10825 6.62654 3.04399 6.4151 3.21397L1.71481 6.99164C1.60814 7.07737 1.50968 7.24224 1.48506 7.35434L1.04199 9.88005C0.959936 10.3285 1.11583 10.7505 1.46045 11.0341C1.75583 11.2649 2.16609 11.3902 2.60917 11.3902C2.70763 11.3902 2.80609 11.3836 2.90455 11.3704L6.05532 11.0143C6.20301 10.9945 6.40812 10.9154 6.50659 10.8297L11.201 7.05673C11.414 6.88554 11.3337 6.59182 11.0567 6.49679C11.0255 6.48611 10.9939 6.47516 10.962 6.46408Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit_icon_white.a8e65ed504981917b25bd1c7114ebd1b.svg";
export { ForwardRef as ReactComponent };